import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const APP_STORE_URL = "https://apps.apple.com/us/app/quaffee-club/id6748536013";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.quaffeeclub";

const getDeviceType = () => {
  const userAgent = window.navigator.userAgent || "";
  const platform = window.navigator.platform || "";
  const maxTouchPoints = window.navigator.maxTouchPoints || 0;

  const isAndroid = /android/i.test(userAgent);
  const isIOS =
    /iPad|iPhone|iPod/i.test(userAgent) ||
    (platform === "MacIntel" && maxTouchPoints > 1);

  if (isIOS) {
    return "ios";
  }

  if (isAndroid) {
    return "android";
  }

  return "unsupported";
};

export default function CheckDeviceType() {
  const { userType } = useParams();
  const [statusMessage, setStatusMessage] = useState("Checking your device...");

  useEffect(() => {
    const storeOwnerRedirectUrl =
      process.env.REACT_APP_QUAFFEE_SHOP_URL?.trim();
    if (userType === "storeOwner") {
      if (storeOwnerRedirectUrl) {
        setStatusMessage("Redirecting store owner...");
        window.location.href = storeOwnerRedirectUrl;
        return;
      }

      setStatusMessage("Store owner redirect is not available right now.");
      return;
    }

    if (userType === "user") {
      const deviceType = getDeviceType();

      if (deviceType === "ios") {
        setStatusMessage("Redirecting to the App Store...");
        window.location.href = APP_STORE_URL;
        return;
      }

      if (deviceType === "android") {
        setStatusMessage("Redirecting to the Play Store...");
        window.location.href = PLAY_STORE_URL;
        return;
      }

      setStatusMessage(
        "Your device is not supported for automatic app-store redirection.",
      );
      return;
    }

    setStatusMessage("Unsupported user type.");
  }, [userType]);

  return (
    <section className="commn-bg-set only-one-respo">
      <div className="card-center-set">
        <div className="commn-card-theme text-center">
          <h2>Redirecting...</h2>
          <p>{statusMessage}</p>
        </div>
      </div>
    </section>
  );
}
